module.exports = __webpack_public_path__ + "img/album14_09.5eb0a74b.jpg";